import { $api } from "../../../../../services/request.config";
import { getSubordinatesAction } from "../getSubordinates.action";

export const getSubordinatesThunkAction = (data) => async (dispatch) => {
    console.log("PIIIIID", data);
    try {
        const response = await $api(`v1/managers/requests/rvd/subordinates/${data.pid}`);
        // const data = [
        //     {
        //         fullName: "Болкунова Анна Олеговна",
        //         fullStructName: "Цифровая лаборатория (г. Москва)",
        //         jobTitle: "Эксперт",
        //         pid: 156276,
        //         tabNumber: "D156276",
        //     },
        // ];
        // dispatch(getSubordinatesAction(data));

        if (response.status === 200) {
            dispatch(getSubordinatesAction(response.data));
        }

    } catch (error) {
        dispatch(getSubordinatesAction([]));
        // throw new Error(error?.response);

    }
};

